import React from "react";
import { useSettings } from "hooks/useStore";
import Link from "components/link";
import Loader from "components/loader";
import { SEARCH_TABS, SCREEN_SIZES } from "utils/constants";
import { useMediaQuery } from "react-responsive";
import BlogItem from "./item/blog";
import ProductItem from "./item/product";
import SearchSuggestions from "./suggestions";
import clsx from "clsx/lite";

const SearchResult = ({ results, query, loading, activeTab, popularData }) => {
	const { toggleSearch, toggleMenu, isMenuOpen } = useSettings(["toggleSearch", "toggleMenu", "isMenuOpen"]);
	const { popularTerms, popularProducts, popularBlogs } = popularData;
	const { products = popularProducts, blogs = popularBlogs, totalProducts, collection } = query ? results : {};
	const isMobile = useMediaQuery({ maxWidth: SCREEN_SIZES.sm });

	const SearchNavLinks = () => (
		<>
			{totalProducts - 4 > 0 &&
					<Link
						onClick={handleClick}
						to={`/search?q=${query}`}
						state={{ activeTab }}
						className="flex underline text-xs underline-offset-2 t-search-all-results-click"
					>
						Show {totalProducts - 4} more results
					</Link>}
			{collection && (
				<Link to={`/collections/${collection.handle}`}
					onClick={handleClick}
					state={{ activeTab }}
					className="justify-end underline text-xs underline-offset-2 t-search-collection-click search-collection-t57-v1"
				>
						Show All {collection.searchLabel}
				</Link>
			)}
		</>
	);

	if (query && !results?.[activeTab]?.length) {
		return (
			<div className="w-full flex justify-center my-auto py-5">
				{loading ? (
					<Loader />
				) : (
					<span className="text-center">No results found</span>
				)}
			</div>
		);
	}

	const handleClick = () => {
		isMenuOpen ? toggleMenu() : toggleSearch();
	};

	return (
		<>
			<div className="pt-2 pb-4 gap-4 hidden md:flex search-t57-v1">
				<SearchNavLinks />
			</div>
			<div className="search-results search-results-t59">
				<SearchSuggestions
					popularTerms={popularTerms}
					results={query ? results.terms : null}
					activeTab={activeTab}
					query={query}
				/>
				<div className="search-results-container">
					{query && (
						<Link to={`/search?q=${query}`}
							onClick={toggleSearch}
							state={{ activeTab }}
							className="hidden md:flex justify-end underline text-sm pb-1.5 t-search-all-results-click search-t57"
						>
							Show all results
						</Link>
					)}
					{!query && <span className="text-secondary best-seller-t59">Best Sellers</span>}
					{activeTab === SEARCH_TABS.PRODUCTS ?
						<div className="products-search-results">
							<div className="hidden-t59 products-search-results">{products.slice(0, 4).map((product, index) => (
								<ProductItem key={index} product={product} index={index} query={query} showModal={false} />
							))}</div>
							<div className={clsx("hidden product-results-t59", query && "mt-2")}>
								{products.slice(0, 9).map((product, index) => (
									<ProductItem key={index} product={product} index={index} query={query} showModal={false} />
								))}</div>
							{totalProducts - 4 > 0 && isMobile &&
								<div className="flex gap-5 flex-row-reverse">
									<SearchNavLinks />
								</div>
							}
						</div>
						:
						<div className="flex gap-3 md:gap-x-8 md:gap-y-5 flex-wrap w-full">
							{blogs.slice(0, isMobile ? 2 : 4).map((blog, index) => (
								<BlogItem key={index} blog={blog} />
							))}
						</div>
					}
				</div>
				{query && !collection && (
					<Link to={`/search?q=${query}`}
						onClick={toggleSearch}
						state={{ activeTab }}
						className="hidden md:flex justify-center self-center border-solid border-[3px] border-black px-12 py-[22px] 
							mt-6 font-black view-results-button-t59 text-sm t-search-all-results-click"
					>
							VIEW ALL RESULTS
					</Link>
				)}
				{collection && (
					<Link to={`/collections/${collection.handle}`}
						onClick={handleClick}
						state={{ activeTab }}
						className="hidden md:flex self-center text-sm border-[3px] border-black px-12 py-[22px] 
							mt-6 font-black view-results-button-t59 t-search-collection-click"
					>
						SHOP ALL {collection.searchLabel.toUpperCase()}
					</Link>
				)}
			</div>
		</>
	);
};

export default SearchResult;
